var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { ThemeProvider as EmotionThemeProvider } from 'emotion-theming';
import { withLocale } from './LocaleProvider';
import baseTheme, { Theme } from '../theme/theme';
var ThemeProvider = function (_a) {
    var l10n = _a.l10n, children = _a.children;
    var brandColors = baseTheme.colors.brand[l10n.theme];
    /**
     * Switching brand colors based on locale
     * We can do this better :s
     */
    var theme = __assign(__assign({ isHome24: (l10n.theme || Theme.h24) === Theme.h24 }, baseTheme), { colors: __assign(__assign({}, baseTheme.colors), { brand: brandColors }) });
    return React.createElement(EmotionThemeProvider, { theme: theme }, children);
};
export default withLocale(ThemeProvider);
